import React from 'react'
import clsx from 'clsx'
import Head from 'next/head'

import About from '@/components/home/sections/About'
import Faq from '@/components/home/sections/Faq'
import Mission from '@/components/home/sections/Mission'
import Promo from '@/components/home/sections/Promo'
import Roadmap from '@/components/home/sections/Roadmap'
import Team from '@/components/home/sections/Team'
import styles from '@/css/home.module.css'
import public_styles from '@/css/public.module.css'
import { truncateWalletAddress } from '@/lib/utils'

const Home = () => {
  const title = 'Refine Web3 + JWT auth in domain-driven design'
  const description =
    'Cutting-edge authentication system that combines the power of web 3 technology with the security of blockchain'

  const smartcontractLink = `https://${
    process.env.NEXT_PUBLIC_SMARTCONTRACT_NETWORK !== 'mainnet'
      ? `${process.env.NEXT_PUBLIC_SMARTCONTRACT_NETWORK}.`
      : ``
  }etherscan.io/address/${process.env.NEXT_PUBLIC_SMARTCONTRACT_ADDRESS}`

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
      </Head>

      <div className={styles.home_page}>
        <Promo />
        <Mission />
        <About />
        <Roadmap />
        <Faq />
        <Team />

        <section className={clsx(public_styles.block, public_styles.align_center, public_styles.pt_0)}>
          <div
            className={clsx(
              public_styles.d_flex,
              public_styles.gutter_05,
              public_styles.flex_flow_wrap,
              public_styles.justify_content_center,
            )}
          >
            SMART CONTRACT ADDRESS:
            <a href={smartcontractLink} title={'Smart contract address'} target={'_blank'} rel={'noreferrer'}>
              <span className={public_styles.d_sm_none}>
                {truncateWalletAddress(process.env.NEXT_PUBLIC_SMARTCONTRACT_ADDRESS!)}
              </span>
              <span className={clsx(public_styles.d_sm_block, public_styles.d_none)}>
                {process.env.NEXT_PUBLIC_SMARTCONTRACT_ADDRESS}
              </span>
            </a>
          </div>
        </section>
      </div>
    </>
  )
}

export default Home
